import { imageMap } from '@/assets/img/imageMap';
import {
  type LotteryReward,
  type LotteryRewardName,
  type TicketRewardType,
} from '@/common/types/lottery';
import { getRewardIconKey } from '@/components/ui/CommonReward/lib';

const ticketPrizes: TicketRewardType[] = [
  'silverTicket',
  'goldTicket',
  'diamondTicket',
];

const isTicketPrize = (name: LotteryRewardName): name is TicketRewardType =>
  ticketPrizes.includes(name as TicketRewardType);

/** The (single) prize of a place / draw result: { tgem: 100 } → tgem, 100. */
const prizeOf = (
  reward?: LotteryReward,
): { name: LotteryRewardName; value: number } | undefined => {
  const name = reward && (Object.keys(reward)[0] as LotteryRewardName);

  return name ? { name, value: reward[name] ?? 0 } : undefined;
};

/** Icon of a prize: T-Gem, dice, ticket — or the USD coin of old seasons. */
const prizeIcon = (name: LotteryRewardName): { png: string; webp?: string } =>
  imageMap[getRewardIconKey(name)];

/** "$5" for the USDT of old seasons, the bare number otherwise. */
const prizeValueText = (
  name: LotteryRewardName,
  value: number | string,
): string => `${name === 'usdt' ? '$' : ''}${value}`;

export { isTicketPrize, prizeIcon, prizeOf, prizeValueText, ticketPrizes };
